import React, { useRef } from "react";
// import logo from "../../media/images/glazma-logo.png";
import logo from "../../media/images/logo512.png";
import { Link } from "react-router-dom";

const LandingNavFemale = ({backupPage}) => {
  const navRef = useRef();

  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  return (
    <div>
    <div className="navbar-main">
    <div className="navbar">
      <div className="nav-logo  female-navlogo-landing-p">
        <Link to="" >
          <img src={logo} alt="logo" />

        {/* <div>   GLAZMA </div>
        <p>  SALON AT HOME</p> */}
        </Link>
        {/* <p>at Home</p> */}
      </div>

      <div className="nav-menu" ref={navRef}>
        <a onClick={showNavbar} href="#services">SERVICES</a>
        {/* <a onClick={showNavbar} href="#packages">PACKAGES</a> */}
        {
          backupPage?"":
        <>
          {/* <a onClick={showNavbar} href="#how-we-deliver">HOW WE DELIVER</a> */}
          <a onClick={showNavbar} href="#why-us">WHY US</a>
          <a onClick={showNavbar} href="#testimonial">TESTIMONIALS</a>
          <a onClick={showNavbar} href="#faqs">FAQ</a>
        </>
        }
        

        <button className="nav-btn nav-close-btn" onClick={showNavbar}>
          <i className="fa-solid fa-circle-xmark"></i>
        </button>
      </div>
      
      <button className="nav-btn menu-btn landing-nav-col">
        <Link to="tel:+918527273020" target="blank"><i class="fa-solid fa-phone"></i>+91 8527273020</Link>
        <i className="fa-solid fa-bars"  onClick={showNavbar}></i>
      </button>
    </div>
    </div>
  </div>
  )
}

export default LandingNavFemale
// export default LandingNavFemale